import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants/index";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import {
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useLocation } from "react-router-dom";

function LeaveApproves() {


  const dispatch = useDispatch();
  const location = useLocation()
  const passedState = location.state;
  useEffect(() => {
    fetchLeaveData();
    dispatch(updateNavbarHeading(passedState ? passedState.text : "Leaves Approved"))
  }, [passedState])



  const [leaveDetails, setLeaveDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined)

  const columns = {
    Code: { text: "EMP ID", align: "start", visible: true },
    Name: { text: "Employee", align: "start", visible: true },
    LeaveType: { text: "Leave Type", align: "center", visible: true },
    DateApplied: { text: "Applied Date", align: "center", visible: true },
    DateApproved: { text: "Approved Date", align: "center", visible: true },
    LeavesDayCount: { text: "No. Of Days", align: "center", visible: true },
    ManagerName: { text: "Manager", align: "start", visible: false },
    Purpose: { text: "Purpose", align: "start", visible: false },
    ManagerName: { text: "Manager", align: "start", visible: false },
    FromDate: { text: "From Date", align: "center", visible: false },
    ToDate: { text: "To Date", align: "center", visible: false },
  };


  const fetchLeaveData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}report/10`);
      setApiStatus(response?.status)
      if (response?.status === 200) {
        const apidata = response?.data?.data;
        setLeaveDetails(apidata);
      }
    } catch (error) {
      console.error("Error Leave Data:", error);
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={leaveDetails}
              columns={columns}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
            />
          </div>
        </div>
      </div>

    </>
  );
}

export default LeaveApproves;
